export default __webpack_public_path__ + "static/media/search.f08742b5.svg";